import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';

import VeracityCheckPage from '../ml-capability-quoteandbind-common-react/pages/VeracityCheck/VeracityCheckPage';
import YourInfoPage from '../gw-capability-quoteandbind-common-react/pages/YourInfo/YourInfoPage';
import QuotePage from '../gw-capability-quoteandbind-common-react/pages/Quote/QuotePage';

import PADriversPage from './pages/Drivers/DriversPage';
import PAVehiclesPage from './pages/Vehicles/VehiclesPage';
import PAAdditionalInformationPage from './pages/AdditionalInformation/AdditionalInformationPage';
import PAPolicyInformationPage from './pages/PolicyInformation/PolicyInformationPage';
import PASuccessPage from './pages/Success/SuccessPage';
import PAPrefillPage from './pages/Prefill/PrefillPage';
import PAAdditionalInformationPreBindPage from './pages/AdditionalInformationPreBind/AdditionalInformationPreBindPage';
import MLPAHVQConsumerDiscrepanciesPage from './pages/MLPAHVQConsumerDiscrepanciesPage/MLPAHVQConsumerDiscrepanciesPage';
import MLPAHVQConsumerDiscrepanciesCheck from './pages/MLPAHVQConsumerDiscrepanciesCheck/MLPAHVQConsumerDiscrepanciesCheck';
import MLHVQDiscrepancyPropertyGroupComponent from './components/MLHVQDiscrepancyPropertyGroupComponent/MLHVQDiscrepancyPropertyGroupComponent';
import MLHVQDiscrepancyPropertyColomnComponent from './components/MLHVQDiscrepancyPropertyColomnComponent/MLHVQDiscrepancyPropertyColomnComponent';
import AgentSelectionPopup from './pages/Prefill/AgentSelectionPopup';

setComponentMapOverrides(
    {
        YourInfoPage: { component: 'YourInfoPage' },
        // PAQualificationPage: { component: 'PAQualificationPage' },
        PADriversPage: { component: 'PADriversPage' },
        PAVehiclesPage: { component: 'PAVehiclesPage' },
        PAAdditionalInformationPage: { component: 'PAAdditionalInformationPage' },
        QuotePage: { component: 'QuotePage' },
        PAPolicyInformationPage: { component: 'PAPolicyInformationPage' },
        PASuccessPage: { component: 'PASuccessPage' },
        PAPrefillPage: { component: 'PAPrefillPage' },
        PAAdditionalInformationPreBindPage: { component: 'PAAdditionalInformationPreBindPage' },
        VeracityCheckPage: { component: 'VeracityCheckPage' },
        MLPAHVQConsumerDiscrepanciesPage: { component: 'MLPAHVQConsumerDiscrepanciesPage' },
        MLPAHVQConsumerDiscrepanciesCheck: { component: 'MLPAHVQConsumerDiscrepanciesCheck' },
        MLHVQDiscrepancyPropertyGroupComponent: { component: 'MLHVQDiscrepancyPropertyGroupComponent' },
        MLHVQDiscrepancyPropertyColomnComponent: { component: 'MLHVQDiscrepancyPropertyColomnComponent'},
        AgentSelectionPopup: { component: 'AgentSelectionPopup'}
    },
    {
        YourInfoPage,
        // PAQualificationPage: QualificationPage,
        PADriversPage,
        PAVehiclesPage,
        PAAdditionalInformationPage,
        QuotePage,
        PAPolicyInformationPage,
        PASuccessPage,
        PAPrefillPage,
        PAAdditionalInformationPreBindPage,
        VeracityCheckPage,
        MLPAHVQConsumerDiscrepanciesPage,
        MLPAHVQConsumerDiscrepanciesCheck,
        MLHVQDiscrepancyPropertyGroupComponent,
        MLHVQDiscrepancyPropertyColomnComponent,
        AgentSelectionPopup
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as PAWizard } from './PAWizard';
export { default as QuotePageDriverTablesComponent } from './components/QuotePageDriverTablesComponent/QuotePageDriverTablesComponent';
export { default as PAPolicySummaryComponent } from './components/PAPolicySummaryComponent/PAPolicySummaryComponent';
export { default as MLHVQDiscrepancyPropertyGroupComponent } from './components/MLHVQDiscrepancyPropertyGroupComponent/MLHVQDiscrepancyPropertyGroupComponent';
export { default as MLHVQDiscrepancyPropertyColomnComponent } from './components/MLHVQDiscrepancyPropertyColomnComponent/MLHVQDiscrepancyPropertyColomnComponent';
export { default as AgentSelectionPopup } from './pages/Prefill/AgentSelectionPopup';